import React from "react";
import { FiCheck, FiClock, FiX } from "react-icons/fi";
import { BsShieldCheck } from "react-icons/bs";
import CheckExclamation from "../../assets/images/checkExclamation.svg";

export const PAGE_TITLE = "Approved Feedstock";
export const BREADCRUMBS = [
  { label: "Home", link: "/" },
  { label: PAGE_TITLE, link: undefined },
];

export const ICONS_MAP = new Map();
ICONS_MAP.set("approved", <FiCheck color="#78BE20" />);
ICONS_MAP.set("approved_with_restrictions", <img src={CheckExclamation} />);
ICONS_MAP.set("homologated", <BsShieldCheck color="#78BE20" />);
ICONS_MAP.set("on_homologation", <FiClock color="#FF8E00" />);
ICONS_MAP.set("not_approved", <FiX color="#EE0000" />);

export const LABELS_MAP = new Map();
LABELS_MAP.set("approved", "Approved");
LABELS_MAP.set("approved_with_restrictions", "Approved with restrictions");
LABELS_MAP.set("homologated", "Homologated");
LABELS_MAP.set("on_homologation", "On homologation");
LABELS_MAP.set("not_approved", "Not approved");

export const HEADER_TABLE_COLUMNS = [
  "Port",
  "PRODUCT",
  "Q1 BA GLOBAL",
  "Q1 BA REFORMA",
  "Q2 RS GLOBAL"
];

export type tableData = {
  port: string;
  origin: string;
  product: string;
  q1BaGlobal: string;
  q1BaReforma: string;
  q2RsGlobal: string;
}